import { AxiosGETRequest, AxiosMutationRequest, RequestMethod } from '@myme/utils';

export const addReviewToMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/reviews'
};

export const addLikeToMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-likes/:mymeId'
};

export const reportMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-reports/myme/:mymeId'
};

export const reportReviewAPI: AxiosMutationRequest = {
  method: RequestMethod.POST,
  path: '/user-reports/review/:reviewId'
};

export const removeLikeFromMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/user-likes/:mymeId'
};

export const removeReviewFromMymeAPI: AxiosMutationRequest = {
  method: RequestMethod.DELETE,
  path: '/reviews/:reviewId'
};

export const getMymeDetailsAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getMymeDetailsAPI'],
  path: '/myme/:mymeId/details'
};

export const getMymeReviewsAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getMymeReviewsAPI'],
  path: '/reviews/:mymeId'
};

export const getMymeParticipationAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getMymeParticipationAPI'],
  path: '/myme/:mymeId/participation'
};

export const getReportReasonsAPI: AxiosGETRequest = {
  method: RequestMethod.GET,
  cacheKeys: ['getReportReasonsAPI'],
  path: '/reports-list'
};
